// extracted by mini-css-extract-plugin
export default {"number_wrap":"style_number_wrap__XGNDu","values":"style_values__iREwm","value":"style_value__kY9zl","total":"style_total__kT5bO"};